import { TableCard } from './TableCard';

function Skeleton({ suffix, prefix }: { suffix?: string; prefix?: string }) {
  return (
    <div data-testid="skeleton" className="m-auto">
      {suffix} <span className="inline-block h-[15px] w-[100px] bg-neutral-200" /> {prefix}
    </div>
  );
}

const DUMMY_DATA = [
  {
    title: <div />,
    sub: [
      <Skeleton suffix="Rp" />,
      <Skeleton suffix="Rp" />,
      <Skeleton suffix="Rp" />,
      <Skeleton />,
      <Skeleton suffix="Rp" />,
      <Skeleton prefix="%" />,
    ],
  },
  {
    title: 'Items',
    sub: [
      <ol className="h-[60px]">
        <li>
          <Skeleton suffix="1." />
        </li>
        <li>
          <Skeleton suffix="2." />
        </li>
        <li>
          <Skeleton suffix="3." />
        </li>
      </ol>,
    ],
  },
];

function DummyTable() {
  return (
    <>
      <TableCard variant="body" id={-1} data={DUMMY_DATA} />
      <TableCard variant="body" id={-1} data={DUMMY_DATA} />
    </>
  );
}

export { DummyTable };
